export const STEP_QUERY_PARAM = 'step'
export const REVIEW_PANE_QUERY_PARAM = 'review'
export const ONBOARDING_TYPE_COOKIE_NAME = 'onboardingTypeCookie'
export const ONBOARDED_AT_COOKIE_NAME = 'onboardedAtCookie'
